<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3"><a id="page_7"></a><strong>IT’S A BLESSIN’ TO BLOW A HUNDRED THOU’ IN A RECESSION</strong></h3>
<p class="noindentb"><span class="small">LYRIC FROM SONG: <strong>“KINDA LIKE A BIG DEAL”</strong> ON ALBUM: <strong>TIL THE CASKET DROPS</strong> BY ARTIST</span>: <strong>CLIPSE</strong></p>
<p class="noindent">One must believe God is looking favorably upon oneself to be able to frivolously spend $100,000 without worrying about how their bank account balance will be affected during a time when most of the population is struggling financially due to an economic crisis.</p>
<h4 class="h4"><a id="page_8"></a><strong>USED TO MAKE A THOUSAND DOLLARS EVERY TIME I PLAYED HOOKY</strong></h4>
<p class="noindentb"><span class="small">LYRIC FROM SONG: <strong>“FEEL ME”</strong> ON ALBUM: <strong>THA CARTER II</strong> BY ARTIST</span>: <strong>LIL WAYNE</strong></p>
<p class="noindent">It is possible that while skipping school, rather than going to the mall, watching a movie, or socializing with friends, one could be engaging in lucrative activities, such as drug dealing, that might yield amounts of money much greater than the average student’s allowance or summer job.</p>
<h4 class="h4"><strong>GRINDIN’ DAILY TO STACK MY BREAD</strong></h4>
<p class="noindentb"><span class="small">LYRIC FROM SONG: <strong>“THEY DON’T KNOW”</strong> ON ALBUM: <strong>THE PEOPLES CHAMP</strong> BY ARTIST</span>: <strong>PAUL WALL</strong></p>
<p class="noindent">I work hard every day, earning income by doing whatever I have to do to get by. As a result of my effort, I am able to pile up the money I make as if it were slices of food made by mixing water with ground flour.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01ch05.vue?7486047f